import moment from 'moment';
import 'moment/locale/ru';

const MOMENT_DATE_FORMAT = 'YYYY-MM-DD';
moment.locale('ru');

(function ($) {
  "use strict";
  $(function () {
    $(document).on('click', '[data-action="address-modal-dismiss"]', () => {
      initTransfer();
    });


    function initTransfer() {
      $.ajax({
        url: '/ajax/cartTransfer.php',
        dataType: 'json',
        data: {
          dateFrom: moment().format(MOMENT_DATE_FORMAT),
        },
        cache: false,
        success: function (data) {
          if (data.success) {
            let calendarWrapper = $('[data-entity="catalog-calendar-wrapper"]');
            let calToday = $(calendarWrapper.find('[data-date="' + moment().format(MOMENT_DATE_FORMAT) + '" ]')[0]);
            calToday.removeClass('js-catalog-menu-day').addClass('day__blocked');
            calToday.removeClass('day_active');
            if (data.dates) {
              let transeferdDateKey = data.dates.to;
              let printDate = moment(transeferdDateKey, MOMENT_DATE_FORMAT).format('D MMMM');
              let calTransferedDate = $(calendarWrapper.find('[data-date="' + transeferdDateKey + '"]')[0]);
              calTransferedDate.find('.js-calendar-day-price').text(calToday.find('.js-calendar-day-price').text());
              calToday.find('.js-calendar-day-price').text('');
              calTransferedDate.click();
              $('[data-entity="cart-transfer-date-to"]').text(printDate);
              $('#cartTransferModal').foundation('open');
            }else{
              if (!calendarWrapper.find('.day_active').length){
                  let tomorrow = moment().add(1,'days').format(MOMENT_DATE_FORMAT);
                  $(calendarWrapper.find('[data-date="' + tomorrow + '" ]')[0]).click();
                }
            }
          }
        },
        error: function (data) {
          console.log(data)
        }
      });
    }

  });
})(jQuery);

